const styles = {
    SIGNUP_CONTAINER : {
        backgroundImage: 'url("https://www.app.linkplease.co/assests/bg.svg")',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
    }
}

export default styles